import type { FormField } from '@elfsight/widget-form-builder/widget';

export function defaultGetDisplayedFields<F extends FormField>(fields: F[]) {
  return fields.filter(({ visible }) => visible || visible === undefined);
}
